<div class="entity-viewer" [ngStyle]="{ opacity: opacity }" *ngIf="visible">
    <h1>Entity Json Viewer</h1>
    <div style="width: 100%">
        <button mat-icon-button (click)="changeOpacity()"><mat-icon>opacity</mat-icon></button>
    </div>
    <pre>
        {{ jsn }}
    </pre>
</div>
